document.addEventListener('mouseover', function (e) {
  var tabButton = e.target.closest('[data-mm-tab]');
  if (!tabButton) return;

  var content = tabButton.closest('.mm-content');
  if (!content) return;

  content.querySelectorAll('.mm-rail__item.is-active').forEach(function (el) {
    el.classList.remove('is-active');
  });
  tabButton.classList.add('is-active');

  var targetId = tabButton.dataset.mmTab;
  content.querySelectorAll('.mm-panel.is-active').forEach(function (el) {
    el.classList.remove('is-active');
  });
  var targetPanel = content.querySelector('.mm-panel[data-mm-panel="' + targetId + '"]');
  if (targetPanel) targetPanel.classList.add('is-active');
});